export default [
    {
      path: '/qa',
      name: 'qa',
      component: () => import(/* webpackChunkName: "tools" */ '../views/qa/main')
    },
    {
      path: '/find_building',
      name: 'find_building',
      component: () => import(/* webpackChunkName: "tools" */ '../views/find_building/index')
    },
    {
      path: '/find_building/result',
      name: 'find_building_result',
      component: () => import(/* webpackChunkName: "tools" */ '../views/find_building/result')
    },
    {
      path: '/taxes/result',
      name: 'taxes_result',
      component: () => import(/* webpackChunkName: "tools" */ '../views/taxes/result.vue')
    },
    {
      path: '/first_payment',
      name: 'first_payment',
      component: () => import(/* webpackChunkName: "tools" */ '../views/first_payment/index.vue')
    },
    {
      path: '/first_payment/result',
      name: 'first_payment_result',
      component: () => import(/* webpackChunkName: "tools" */ '../views/first_payment/result.vue')
    },
    {
      path: '/prepayment_calc',
      name: 'prepayment_calc',
      component: () => import(/* webpackChunkName: "tools" */ '../views/prepayment_calc/index.vue')
    },
    {
      path: '/prepayment_calc/result',
      name: 'prepayment_calc_result',
      component: () => import(/* webpackChunkName: "tools" */ '../views/prepayment_calc/result.vue')
    },
    {
      path: '/prepayment_calc/help',
      name: 'prepayment_calc_help',
      component: () => import(/* webpackChunkName: "tools" */ '../views/prepayment_calc/help.vue')
    },
    {
      path: '/check_condition',
      name: 'check_condition',
      component: () => import(/* webpackChunkName: "tools" */ '../views/check_condition/main.vue')
    },
    {
      path: '/check_condition_verify',
      name: 'check_condition_verify',
      component: () => import(/* webpackChunkName: "tools" */ '../views/check_condition/verify/main.vue')
    },
    {
      path: '/packageA/loan_computer/main',
      name: '/packageA/loan_computer/main',
      component: () => import(/* webpackChunkName: "tools" */ '../views/packageA/loan_computer/main')
    },
    {
      path: '/loan_computer_result',
      name: 'loan_computer_result',
      component: () => import(/* webpackChunkName: "tools" */ '../views/loan_computer/result/main.vue')
    },
    {
      path: '/loan_computer/help',
      name: 'loan_computer_help',
      component: () => import(/* webpackChunkName: "tools" */ '../views/loan_computer/help.vue')
    },
    {
      path: '/loan_computer/loan_rate',
      name: 'loan_computer_loan_rate',
      component: () => import(/* webpackChunkName: "tools" */ '../views/loan_computer/loan_rate.vue')
    },
    {
      path: '/taxes',
      name: 'taxes',
      component: () => import(/* webpackChunkName: "tools" */ '../views/taxes/index.vue')
    },
    {
      path: '/img_preview',
      name: 'img_preview',
      component: () => import(/* webpackChunkName: "tools" */ '../views/img_preview/index.vue')
    },
    {
      path: '/map',
      name: 'map',
      component: () => import(/* webpackChunkName: "tools" */ '../views/map/index.vue')
    },
]